import * as Mamba from '@mamba/clients';
import lodash from 'lodash';
import NProgress from 'nprogress';
import { $AppConfig } from './global';
Mamba.AuthEncryption.AES_Config.set({
  ...$AppConfig.userAgent.Parsed,
  userAgent: window.navigator.userAgent,
});
if ($AppConfig.production) {
  Mamba.Log.group = $AppConfig.userAgent.isDesktop;
}
Mamba.AjaxBasics.resetDefault({
  headers: {
    'x-client-info': `platform=${Mamba.EnumPlatform.mobile};version=${$AppConfig.version}`,
  },
});
Mamba.AjaxBasics.onStart = (AjaxConfig) => {
  if (!AjaxConfig.ignoreLoading) {
    NProgress.start();
  }
  if (AjaxConfig?.loading) {
  }
};
Mamba.AjaxBasics.onEndAll = () => {
  NProgress.done();
};
let loginOutting = false;
Mamba.AjaxBasics.onError = async (error, AjaxConfig) => {
  if (lodash.eq(error.responseType, 'blob')) {
    let reader = new FileReader();
    reader.onload = () => {
      let content = String(reader.result);
    };
    reader.readAsText(error.response);
    return;
  }
  if (lodash.eq(error.message, 'ajax timeout')) {
    error.message = '当前访问用户过多,请稍后再试.';
  }
  const msg = lodash.find(
    lodash.compact([
      lodash.get(error, 'message'),
      '当前访问用户过多,请稍后再试.',
    ]),
    lodash.isString,
  );
  const status = lodash.get(error, 'status');
  if (lodash.includes([14011], status)) {
    return console.warn('产品的错误不处理');
  }

  if (
    lodash.includes(
      [
        // 14011,
        304,
        6001,
        6002,
        'A0230',
        'A0301',
        'ABusiness-4003',
      ],
      status,
    )
  ) {
    if (loginOutting) {
      return;
    }
    loginOutting = true;
    loginOutting = false;
    return;
  }
  if (lodash.eq(msg, 'ajax error')) {
    return;
  }
  if (!AjaxConfig.ignoreLoading) {
  }
};
